import { Origin } from '../interfaces/users';

/**
 * O backend só envia as flags de bloqueio por estabelecimento quando elas valem `true`.
 * Numa unidade liberada o campo simplesmente não vem na resposta — não vem como `false`,
 * não vem como `null`. Por isso qualquer valor falsy, inclusive a ausência do campo,
 * significa liberado.
 *
 * As flags já chegam resolvidas: o backend aplica tanto a lista de bloqueio quanto a de
 * habilitação da unidade, então o front não precisa saber qual das duas está em uso.
 */
export const isEstablishmentBlockedForMedicines = (origin?: Origin | null): boolean =>
  Boolean(origin?.BloquearEstabelecimentosParaMedicamentos);

export const isEstablishmentBlockedForFormulas = (origin?: Origin | null): boolean =>
  Boolean(origin?.BloquearEstabelecimentosParaFormulas);

export const isEstablishmentBlockedForExams = (origin?: Origin | null): boolean =>
  Boolean(origin?.BloquearEstabelecimentosParaExames);

export const isEstablishmentBlockedForMedicalCertificates = (origin?: Origin | null): boolean =>
  Boolean(origin?.BloquearEstabelecimentosParaAtestados);

export const isEstablishmentBlockedForMedicalReferrals = (origin?: Origin | null): boolean =>
  Boolean(origin?.BloquearEstabelecimentosParaEncaminhamentos);

export const isEstablishmentBlockedForMedicalReports = (origin?: Origin | null): boolean =>
  Boolean(origin?.BloquearEstabelecimentosParaRelatorios);
